import IndexPage from '../../components/pages/homes/IndexPage.vue'
export default {
  components: { IndexPage }
}
